import { z } from "zod";
export const tagSummary = z.object({
    id: z.uuid(),
    name: z.string(),
    studyCount: z.number().int(),
});
export const tagList = z.object({ items: z.array(tagSummary) });
export const renameTagInput = z.object({
    name: z.string().trim().min(1).max(50),
});
export const mergeTagInput = z.object({
    intoId: z.uuid(),
});
//# sourceMappingURL=tag.js.map